import { useMemo } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { useTranslation } from "react-i18next"
import { addDays } from "date-fns"
import { NewsEndDatePicker } from "@/modules/admin/news/components/sections/news-end-date-picker"
import { NewsStartDatePicker } from "@/modules/admin/news/components/sections/news-start-date-picker"
import { NewsTimeInput } from "@/modules/admin/news/components/sections/news-time-input"
import { NewsForm } from "@/modules/admin/news/types"

const NewsSectionDurationForm = () => {
  const { t } = useTranslation()
  const form = useFormContext<NewsForm>()
  const {
    control,
    setValue,
    formState: { errors },
  } = form

  const startDate = form.getValues("startDate")

  const fromDateInEndDate = useMemo(() => {
    const date = new Date()
    return date && startDate <= addDays(date, -1) ? date : startDate
  }, [startDate])

  return (
    <>
      <div className="grid grid-cols-2 gap-4">
        <Controller
          name="startDate"
          control={control}
          render={({ field: { value } }) => (
            <NewsStartDatePicker
              form={form}
              label={t("patient.agenda.timeWindowForm.startDate")}
              error={errors?.startDate?.message || ""}
              defaultValue={value}
              setError={(message) => form.setError("startDate", { type: "manual", message })}
              onSelect={(value) => setValue("startDate", value!, { shouldValidate: true })}
            />
          )}
        />
        <Controller
          name="startTime"
          control={control}
          render={({ field: { value, onChange, onBlur, ref } }) => (
            <NewsTimeInput
              ref={ref}
              testId="news-start-time"
              label={t("admin.news.form.startTime")}
              required
              value={value}
              error={errors.startTime?.message}
              translateError
              errorClasses="truncate"
              onChange={onChange}
              onBlur={onBlur}
            />
          )}
        />
      </div>
      <div className="grid grid-cols-2 gap-4">
        <Controller
          name="endDate"
          control={control}
          render={({ field: { value } }) => (
            <NewsEndDatePicker
              form={form}
              fromDate={fromDateInEndDate}
              label={t("patient.agenda.timeWindowForm.endDate")}
              error={errors?.endDate?.message || ""}
              defaultValue={value}
              onSelect={(value) => setValue("endDate", value, { shouldValidate: true })}
            />
          )}
        />
        <Controller
          name="endTime"
          control={control}
          render={({ field: { value, onChange, onBlur, ref } }) => (
            <NewsTimeInput
              ref={ref}
              testId="news-end-time"
              label={t("admin.news.form.endTime")}
              value={value}
              error={errors.endTime?.message}
              translateError
              errorClasses="truncate"
              onChange={onChange}
              onBlur={onBlur}
            />
          )}
        />
      </div>
    </>
  )
}

export default NewsSectionDurationForm
